<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import type { SpecialConditions } from '~/layers/forms/models'
import { Form } from '~/layers/forms/models'

interface Props {
  modelValue: SpecialConditions
}

const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)

const v$ = useValidation(() => ({}), model, {
  $scope: Form.specialConditions,
  $registerAs: Form.specialConditions,
})
</script>

<template>
  <FormsGlobalContainer :identifier="Form.specialConditions">
    <FormsGlobalTitle
      text="Condiciones especiales"
      icon-class="icon-[ph--person-simple-circle-bold]"
    />

    <InputContainer
      label="Diabético"
      :error="v$.militar?.$error"
      :error-message="v$.militar?.$errors[0]?.$message.toString()"
    >
      <PvCheckbox
        v-model="model.militar"
        :binary="true"
      />
    </InputContainer>

    <InputContainer
      label="Hípertenso"
      :error="v$.hypertense?.$error"
      :error-message="v$.hypertense?.$errors[0]?.$message.toString()"
    >
      <PvCheckbox
        v-model="model.hypertense"
        :binary="true"
      />
    </InputContainer>

    <InputContainer
      label="Militar"
      :error="v$.diabetic?.$error"
      :error-message="v$.diabetic?.$errors[0]?.$message.toString()"
    >
      <PvCheckbox
        v-model="model.diabetic"
        :binary="true"
      />
    </InputContainer>

    <InputContainer
      label="Fumador"
      :error="v$.smoker?.$error"
      :error-message="v$.smoker?.$errors[0]?.$message.toString()"
    >
      <PvCheckbox
        v-model="model.smoker"
        :binary="true"
      />
    </InputContainer>
  </FormsGlobalContainer>
</template>
